import React from "react";
import {
  Create,
  Edit,
  TextInput,
  DateInput,
  SelectInput,
  ReferenceInput
} from "admin-on-rest";
// /SelectArrayInput
import RichTextInput from "aor-rich-text-input";
import { IconTitle } from "../components";
import CampaignForm from "./CampaignForm";

const toolbar = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ["blockquote"],
  ["clean"]
];

const CampaignDefaultValue = {
  youtube_url: "",
  media_url: ""
};

const validateCampaigns = values => {
  const errors = {};
  if (!values.name) {
    errors.name = ["The name is required"];
  }

  return errors;
};
const CampaignFormField = props => (
  <CampaignForm
    {...props}
    defaultValues={CampaignDefaultValue}
    validate={validateCampaigns}
  >
    <TextInput label="resources.campaigns.fieldList.name" source="name" />
    <DateInput
      label="resources.campaigns.fieldList.start_date"
      source="start_date"
    />
    <DateInput
      label="resources.campaigns.fieldList.end_date"
      source="end_date"
    />
    <SelectInput
      label="resources.campaigns.fieldList.status.title"
      source="status"
      choices={[
        {
          id: "Active",
          name: "resources.campaigns.fieldList.status.choices.active"
        },
        {
          id: "Suspended",
          name: "resources.campaigns.fieldList.status.choices.suspended"
        },
        {
          id: "Cancelled",
          name: "resources.campaigns.fieldList.status.choices.cancelled"
        },
        {
          id: "Completed",
          name: "resources.campaigns.fieldList.status.choices.completed"
        }
      ]}
    />
    <ReferenceInput
      label={"resources.campaigns.fieldList.categories"}
      source="category_id"
      reference="categories"
      perPage={1000}
      allowEmpty
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    {/* <ReferenceArrayInput
      label={"resources.campaigns.fieldList.microsites"}
      source="microsites"
      reference="contents"
      perPage={1000}
      allowEmpty
    >
      <SelectArrayInput optionText="title" />
    </ReferenceArrayInput> */}
    <RichTextInput source="description" toolbar={toolbar} />
    <TextInput
      label="resources.campaigns.fieldList.youtube_url"
      source="youtube_url"
    />
    <TextInput
      label="resources.campaigns.fieldList.media_url"
      options={{ fullWidth: true }}
      source="media_url"
    />
  </CampaignForm>
);

export const CampaignCreate = props => (
  <Create
    {...props}
    title={<IconTitle icon="accounts" title={"resources.campaigns.title"} />}
  >
    <CampaignFormField {...props} />
  </Create>
);

export const CampaignEdit = props => (
  <Edit
    {...props}
    title={<IconTitle icon="accounts" title={"resources.campaigns.title"} />}
  >
    <CampaignFormField {...props} />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/campaigns/Create.js